'use client';

import { c as _c } from "react/compiler-runtime";
import { Body, H5 } from '@material-bank/mb3-components';
import { SuccessCheck } from '@material-bank/mtag-ui-components';
import { useTranslations } from '@material-bank/i18n';
import { useAuthProvider } from '../../../providers/AuthProvider';
export function SuccessStep() {
  const $ = _c(29);
  const t = useTranslations("authentication.dialog.success");
  const {
    user
  } = useAuthProvider();
  let T0;
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== t || $[1] !== user?.firstName) {
    const firstName = user?.firstName?.trim();
    t4 = "status";
    t5 = "flex flex-col items-center gap-4 px-6 pt-4 pb-12 text-center";
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <SuccessCheck />;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    t3 = "flex flex-col gap-1";
    T0 = H5;
    t0 = "semibold";
    t1 = "text-foreground text-balance";
    t2 = firstName ? t("titleWithName", {
      firstName
    }) : t("title");
    $[0] = t;
    $[1] = user?.firstName;
    $[2] = T0;
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    T0 = $[2];
    t0 = $[3];
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
    t6 = $[9];
  }
  let t7;
  if ($[11] !== T0 || $[12] !== t0 || $[13] !== t1 || $[14] !== t2) {
    t7 = <T0 weight={t0} className={t1}>{t2}</T0>;
    $[11] = T0;
    $[12] = t0;
    $[13] = t1;
    $[14] = t2;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t) {
    t8 = t("description");
    $[16] = t;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t8) {
    t9 = <Body className="text-muted-foreground">{t8}</Body>;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t3 || $[21] !== t7 || $[22] !== t9) {
    t10 = <div className={t3}>{t7}{t9}</div>;
    $[20] = t3;
    $[21] = t7;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t10 || $[25] !== t4 || $[26] !== t5 || $[27] !== t6) {
    t11 = <div role={t4} className={t5}>{t6}{t10}</div>;
    $[24] = t10;
    $[25] = t4;
    $[26] = t5;
    $[27] = t6;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  return t11;
}